import { Publication } from '../models'
import { getDateFormattedSmall } from './date-helpers'

export const isSafari = (): boolean => {
  const userAgent = window.navigator.userAgent
  const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent)
  return isSafari
}

export const getFilteredPublications = (
  filterText: string,
  bigPublicationList: Publication[]
): Publication[] => {
  let list: Publication[] = bigPublicationList

  if (filterText) {
    const textValue = filterText.toLowerCase()
    list = list.filter(publication => {
      return (
        publication?.name?.toLowerCase().includes(textValue) ||
        getDateFormattedSmall(publication.created)?.toLowerCase().includes(textValue)
      )
    })
  }

  return list
}
